import { render } from "./MsTextarea.vue?vue&type=template&id=62b0cad4&scoped=true"
import script from "./MsTextarea.vue?vue&type=script&lang=js"
export * from "./MsTextarea.vue?vue&type=script&lang=js"

import "./MsTextarea.vue?vue&type=style&index=0&id=62b0cad4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b0cad4"]])

export default __exports__